import { useDispatch } from 'react-redux';
import { setExperimentSwitches } from '../actions/lister-actions';
import { useEventListener } from './useEventListener';

export const useExperimentSwitch = () => {
	const dispatch = useDispatch();

	const getExperimentSwitch = () => {
		const experimentSwitches = window.AoListerPageExperiments;
		if (!experimentSwitches) {
			return null;
		}

		dispatch(setExperimentSwitches(experimentSwitches));
		return null;
	};

	useEventListener('dy-experiment-switch', getExperimentSwitch);
};
export default useExperimentSwitch;
